import { AuthContext } from 'contexts'

export const useCurrentUser = () => {
  const { setRole, role, userId } = AuthContext.useAuthContext()

  return { setRole, role, userId }
}
